import {ObjectUtil} from '../../util/object-util';

export class PreviousDamage {

  id: string = null;
  year: number = null;
  amountPaid: number = 0;
  currency: string = 'EUR';
  type: string = null;

  public constructor(object?: Object) {
    ObjectUtil.assign(this, object);
  }
}
